var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.539615,
    d: "M0.134114 24.18L0.109971 19.8578C2.07016 19.4639 3.43933 18.6574 4.21747 17.4383C4.99562 16.2191 5.37601 14.0551 5.35864 10.9461L0.354764 10.9837L0.294407 0.178187L9.9097 0.106008L9.96053 9.20539C9.98679 13.9067 9.2549 17.5521 7.76487 20.1416C6.27526 22.8069 3.73168 24.153 0.134114 24.18ZM14.2627 24.074L14.2386 19.7518C16.1988 19.3579 17.5679 18.5514 18.3461 17.3322C19.1242 16.1131 19.5046 13.949 19.4872 10.8401L14.4834 10.8776L14.423 0.0721273L24.0383 -5.24521e-05L24.0891 9.09933C24.1154 13.8007 23.3835 17.4461 21.8935 20.0355C20.4039 22.7008 17.8603 24.047 14.2627 24.074Z",
    fill: "#6BCF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteEnd);
export default __webpack_public_path__ + "static/media/quote-end.ba1b9c711eb4a7302f6898861b153027.svg";
export { ForwardRef as ReactComponent };